
export default {
  name: 'CarouselIndicators',
  props: {
    total: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    arrayOfIndexes () {
      return Array.from({ length: this.total }, k => k)
    },
  },
}
